import {
    OnboardingModel,
    OnboardingPayload,
} from '../../../../types/RsvpOnboarding';
import { DBWriterLoggerFunction } from '../../../../types/logger';
import { UserModel } from '../../../../types/User';
import { UserOnboardingPayload } from '../../../../types/RsvpOnboarding';

export const prepareUpdateOnboarding = ({
    onboardingElement,
    payload,
}: {
    onboardingElement: OnboardingModel;
    payload: OnboardingPayload;
}) =>
    onboardingElement.prepareUpdate((rsvpOnboardingElement) => {
        rsvpOnboardingElement.isAppointmentOnboarded =
            payload.isAppointmentOnboarded ??
            onboardingElement.isAppointmentOnboarded;
        rsvpOnboardingElement.isInvitationOnboarded =
            payload.isInvitationOnboarded ??
            onboardingElement.isInvitationOnboarded;
        rsvpOnboardingElement.isBannerOnboarded =
            payload.isBannerOnboarded ?? onboardingElement.isBannerOnboarded;
        rsvpOnboardingElement.isDeclinedAppointmentsOnboarded =
            payload.isDeclinedAppointmentsOnboarded ??
            onboardingElement.isDeclinedAppointmentsOnboarded;
        rsvpOnboardingElement.dashboardGettingStartedSectionDismissed =
            payload.dashboardGettingStartedSectionDismissed ??
            onboardingElement.dashboardGettingStartedSectionDismissed;
        rsvpOnboardingElement.areBusinessDetailsOnboarded =
            payload.areBusinessDetailsOnboarded ??
            onboardingElement.areBusinessDetailsOnboarded;
        rsvpOnboardingElement.areEntriesOnboarded =
            payload.areEntriesOnboarded ??
            onboardingElement.areEntriesOnboarded;
        rsvpOnboardingElement.areInvoicesOnboarded =
            payload.areInvoicesOnboarded ??
            onboardingElement.areInvoicesOnboarded;
        rsvpOnboardingElement.areProceduresOnboarded =
            payload.areProceduresOnboarded ??
            onboardingElement.areProceduresOnboarded;
    });

export const prepareUpdateOnboardingUser = ({
    user,
    payload,
}: {
    user: UserModel;
    payload: UserOnboardingPayload;
}) =>
    user.prepareUpdate((userElement) => {
        userElement.isInvoicingAccountSetupSet =
            payload.isInvoicingAccountSetupSet ??
            userElement.isInvoicingAccountSetupSet;
    });

export const logUpdateOnboardingAction = ({
    onboarding,
    user,
    logDBAction,
    tableName,
}: {
    onboarding: OnboardingModel;
    user?: UserModel;
    logDBAction: DBWriterLoggerFunction;
    tableName: string;
}) => {
    logDBAction({
        message: 'Update RSVP onboarding',
        modelName: tableName,
        payload: onboarding,
    });

    if (user) {
        logDBAction({
            message: 'Update user',
            modelName: 'users',
            payload: user,
        });
    }
};
